import { serviceLocator } from '@/utils/providers/serviceLocator'
import { CouponsRepository } from '../repositories/CouponsRepository'
import { useQuery } from '@/utils/asyncStateManagement/useQuery'

export async function getCouponByIdCase(id: number) {
  const newRepository = serviceLocator.getService<CouponsRepository>('CouponsService')
  const { data } = await useQuery({
    fetcher: async () => await newRepository?.getCouponById(id),
    key: 'coupon',
    filterData: JSON.stringify(id)
  })
  if (data.value?.error) return
  return data.value
}
